ACC.browserCookies = {
  colorboxCls: function(href, close, width) {
    $.colorbox({
      inline: true,
      href: href,
      width: '100%',
      maxWidth: width,
      scrolling: true,
      overlayClose: false,
      escKey: true,
      close: close,
      onComplete: function() {
        $('#colorbox').removeClass(ACC.thirtyDayMask.shippingPopupCls);
      },
      onClosed: function() {
        $.colorbox.close();
      }
    });
  },
  browserPopupParentfun: function() {
    var popupWidth = 640,
        href = '#ph-browser-cookiespopup',
        close = '<button type=\'button\' class=\'ph-cbox-close\' id=\'ph-cboxClose\'><span class=\'ph-icon-cross\'></span></button>';

    var browserVersion = {
      chrome: 64,
      edge: 44,
      msie: 11,
      mozilla: 65,
      safari: 11
    };

    if ($.browser.msedge === true && $.browser.versionNumber < browserVersion.edge) {
      ACC.browserCookies.colorboxCls(href, close, popupWidth);
    }

    if ($.browser.mozilla === true && $.browser.versionNumber < browserVersion.mozilla) {
      ACC.browserCookies.colorboxCls(href, close, popupWidth);
    }

    if ($.browser.msie === true && $.browser.versionNumber < browserVersion.msie) {
      ACC.browserCookies.colorboxCls(href, close, popupWidth);
    }

    ACC.browserCookies.browserPopupsecond(href, close, popupWidth, browserVersion);
  },
  browserPopupsecond: function(href, close, popupWidth, browserVersion) {
    if ($.browser.safari === true && $.browser.versionNumber < browserVersion.safari) {
      ACC.browserCookies.colorboxCls(href, close, popupWidth);
    }

    if ($.browser.chrome === true && $.browser.versionNumber < browserVersion.chrome) {
      ACC.browserCookies.colorboxCls(href, close, popupWidth);
    }
  }
};
$(document).ready(function() {
  if (ACC.healthcare.getCookieValue('isBrowserPopUp') !== 'true') {
    document.cookie = 'isBrowserPopUp=false;path=/';
  }

  if (ACC.healthcare.getCookieValue('isBrowserPopUp') === 'false') {
    ACC.browserCookies.browserPopupParentfun();
  }

  $('.ph-terms_popup_agree').click(function() {
    document.cookie = 'isBrowserPopUp=true;path=/';
  });
});
